// import {MenuItem} from './menu.model';
import * as pubsub from "pubsub-js"
import {environment} from "../../../environments/environment";

export const BASELINK = '/nueva-banca-digital'

export const IGNORE_VALIDATE_ROUTES = ['/', '/login', '/token-unlock', '/reset-password']
export const MAIN_MENU: any[] = [
    {
        id: 1020,
        styleClass: "inverse-row",
        expanded: false,
        items: [
            {
                id: 1032,
                routerLink: `${BASELINK}/destinatarios`,
                requirePermission: false,
                command: () => {
                    command(1020, 1032)
                },
                label: 'Destinatarios'
            }
        ],
        icon: 'icon-destinatarios',
        index: 13,
        order: 13,
    },
    {
        id: 1042,
        styleClass: "inverse-row",
        expanded: false,
        items: [
            {
                id: 1081,
                routerLink: `${BASELINK}/pagos/cedes/certificado-deposito`,
                requirePermission: false,
                command: () => {
                    command(1042, 1081)
                },
                label: 'menu.cedes.submenu.CD'
            }
        ],
        icon: 'inversiones',
        index: 11,
        order: 5,
    },

    {
        id: 1064,
        styleClass: "inverse-row",
        icon: 'icon-pagos',
        expanded: false,
        items: [
            {
                id: 1023,
                routerLink: `${BASELINK}/pagos/nacional`,
                requirePermission: false,
                command: () => {
                    command(1064, 1023)
                },
                label: 'Nacionales'
            },
            {
                id: 1024,
                routerLink: `${BASELINK}/pagos/internacional`,
                requirePermission: false,
                command: () => {
                    command(1064, 1024)
                },
                label: 'Internacionales'
            }
        ],
        index: 6,
        order: 6,
    },
    {
        id: 'MONEX_ULTRA',
        label: 'MONEX_ULTRA_MENU_OPTION',
        icon: 'icon-ultra-dos',
        requirePermission: false,
        command: () => {
            pubsub.publish("OPEN_VALIDATION_TOKEN_TO_MONEX_ULTRA")
        },
        index: 4,
        order: 4,
    }
    //id: 1018 consulta dinamica - https://consultadinamica.monex.com.mx/
]

export const COMMON_MENU = [
    {
        label: `PREVIOUS_BANK_LABEL`,
        nombre: `PREVIOUS_BANK_LABEL`,
        id: 'REDIRECT',
        url: environment.bancaDigitalPage,
        target: "_self",
        requirePermission: true,
        permissionFunction: 'showPreviousBank',
        icon: 'icon-banca-digital-anterior',
        index: 14,
        order: 14,
    },
    {
        id: 'NOTIFICATIONS',
        label: "menu.root",
        nombre: "menu.root",
        styleClass: "inverse-row",
        icon: 'centro-notificaciones',
        requirePermission: false,
        expanded: false,
        visible: true,
        items: [
            {
                id: 'CMD_CARGA',
                routerLink: `${BASELINK}/destinatarios/autorizacion/single`,
                label: 'menu.submenu.CMD_AUTO',
                nombre: 'menu.submenu.CMD_AUTO',
                requirePermission: false,
                command: () => {
                    command('NOTIFICATIONS', 'CMD_CARGA')
                },
            },
            {
                id: 'CMP_CARGA',
                routerLink: `${BASELINK}/pagos/autorizacion/single`,
                label: 'menu.submenu.CMP_AUTO',
                nombre: 'menu.submenu.CMP_AUTO',
                requirePermission: false,
                command: () => {
                    command('NOTIFICATIONS', 'CMP_CARGA')
                },
            },
        ],
        index: 1,
        order: 1,
    },
    {
        id: 'idMancomunidadMenu',
        label: "menu.mancomunidad.root",
        nombre: "menu.mancomunidad.root",
        styleClass: "inverse-row",
        icon: 'icon-mancomunidad',
        expanded: false,
        requirePermission: true,
        permissionFunction: 'hasFacultadesPermission',
        items: [
            {
                id: 'idFacultadesMenu',
                routerLink: `${BASELINK}/pagos/mancomunados/facultades`,
                label: 'menu.mancomunidad.submenu.facultades',
                nombre: 'menu.mancomunidad.submenu.facultades',
                requirePermission: false,
                command: () => {
                    command('idMancomunidadMenu', 'idFacultadesMenu')
                },
            },
            {
                id: 'idMancomunidadAutorizacionMenu',
                routerLink: `${BASELINK}/pagos/mancomunados/autorizacion`,
                label: 'menu.mancomunidad.submenu.authorization',
                nombre: 'menu.mancomunidad.submenu.authorization',
                requirePermission: false,
                command: () => {
                    command('idMancomunidadMenu', 'idMancomunidadAutorizacionMenu')
                },
            }
        ],
        index: 11,
        order: 11,
    }

]
export const command = (id: any, subId: any = 1018) => {
    const mainMenu = MAIN_MENU.map(x => ({...x}));
    const baseMenu = COMMON_MENU.map(x => ({...x}));
    let option = mainMenu.find(x => x.id == id);
    if (!option) {
        option = baseMenu.find(x => x.id == id);
    }
    const command: any = {}
    command.subItems = !option ? [] : option.items
    command.subId = subId;
    pubsub.publish("rowMenu", command)
    return command
}

// Orden de menu
// 1 Centro de notificaciones
// 2 Consulta Dinámica
// 3 ULTRA FX
// 4 Ultra II
// 5 Inversiones
// 6 Pagos
// 7 Impuestos
// 8 Derivados
// 9 Crédito
// 10 HUB
// 11 Facultades mancomunadas
// 12 Cobranza
// 13 Administración de cuenta
// 14 Monex Trader

